module.exports = __webpack_public_path__ + "static/media/logo.2810a88b.svg";